<template>
  <div>
    <confirm-modal
        v-model="modalExcluir"
        @modalAcaoCancelar="fecharModalExcluir"
        @modalAcaoConfirmar="excluirServico"
        :persistencia="false"
        mensagemInicial="Deseja realmente excluir o serviço "
        :mensagemMeio="servicoAtendimento.titulo"
        mensagemFinal="?"/>
    <v-dialog v-model="model" max-width="400" scrollable persistent>
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>Editar Serviço</v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 pb-0">
                <div class="detalhes-servico">
                  <span>Título</span><br/>
                  <label class="max-label">{{ dadosGerais.titulo }}</label>
                </div>
              </v-col>
            </v-row>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 pb-0">
                <div class="detalhes-servico">
                  <span>Descrição</span><br/>
                  <label class="max-label-line">{{ dadosGerais.descricao }}</label>
                </div>
              </v-col>
            </v-row>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 pb-0">
                <v-textarea
                    v-model="dadosGerais.observacao"
                    name="observacao"
                    placeholder="Adicione uma observação"
                    filled
                    auto-grow
                    counter="300"
                    maxlength="300"
                    v-validate="{required: false, min: 5, max: 300}"
                    :error-messages="errors.collect('observacao')">
                  <template v-slot:label>Observação</template>
                </v-textarea>
              </v-col>
            </v-row>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 pb-0">
                <v-text-field
                    v-model="dadosGerais.quantidade"
                    name="quantidade"
                    placeholder="Informe a quantidade"
                    type="number"
                    v-validate="{required: true}"
                    :error-messages="errors.collect('quantidade')">
                  <template v-slot:label>
                    Quantidade <span class="ml-1 red--text">*</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row wrap align-center white>
              <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 pb-0">
                <input-valor
                    v-model="dadosGerais.valor"
                    label="Valor"
                    placeholder="Informe o valor do serviço"
                    hideDetails
                    :event-submit="'blur'"
                    :prefix="prefixo"
                    :suffix="sufixo"
                    :precision="casasDecimais"
                    @blur="(valor) => dadosGerais.valor = valor"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <botao-excluir :disabled="!dadosGerais.servicoId" @excluir="abrirModalExcluir" class="ml-4" color="grey"/>
          <v-spacer/>
          <v-btn @click="fecharModal" outlined>Voltar</v-btn>
          <v-btn @click="EditarServico" depressed class="primary ml-5">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import _ from 'lodash'
import {actionTypes} from '@/core/constants'
import InputValor from '@/views/components/InputValor.vue'
import ConfirmModal from '@/views/components/ConfirmModal.vue'
import BotaoExcluir from '@/views/components/BotaoExcluir.vue'

export default {
    name: 'ServicoAtendimentoEditarModal',
    components: {BotaoExcluir, ConfirmModal, InputValor},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        servicoAtendimento: {
            type: Object,
            required: true
        },
        atendimentoId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            dadosGerais: {
                servicoId: null,
                observacao: null,
                quantidade: null,
                valor: null
            },
            modalExcluir: false,
            prefixo: 'R$',
            sufixo: '',
            casasDecimais: 2,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    beforeMount() {
        this.setarDadosIniciais()
    },
    methods: {
        setarDadosIniciais() {
            this.dadosGerais = _.cloneDeep(this.servicoAtendimento)
        },
        async EditarServico() {
            if (await this.validarDadosFormulario()) {
                const input = {
                    servicoId: this.dadosGerais.servicoId,
                    atendimentoId: this.atendimentoId,
                    observacao: this.dadosGerais.observacao,
                    quantidade: this.dadosGerais.quantidade,
                    valor: this.dadosGerais.valor
                }
                this.setMensagemLoading('Atualizando serviço...')
                await this.$store.dispatch(actionTypes.SERVICO_ATENDIMENTO.EDITAR_SERVICO, input)
                this.mostrarNotificacaoSucessoDefault()
                this.fecharModal()
            }
        },
        async validarDadosFormulario() {
            return this.$validator._base.validateAll()
        },
        fecharModal() {
            this.model = false
            this.$emit('fecharModalEditarServicoAtendimento')
        },
        abrirModalExcluir() {
            this.modalExcluir = true
        },
        fecharModalExcluir() {
            this.modalExcluir = false
        },
        async excluirServico() {
            const input = {servicoId: this.dadosGerais.servicoId, atendimentoId: this.atendimentoId}
            await this.$store.dispatch(actionTypes.SERVICO_ATENDIMENTO.EXCLUIR_SERVICO, input)
            this.mostrarNotificacaoSucessoDefault()
            this.fecharModalExcluir()
            this.fecharModal()
        }
    }
}
</script>

<style scoped lang="stylus">

.detalhes-servico
  padding 10px 5px 10px 5px
  border-radius 5px

  span
    font-weight bold
    color var(--theme-primary)

.max-label
  display inline-block
  max-width 300px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

.max-label-line
  display -webkit-box
  max-width 300px
  overflow hidden
  text-overflow ellipsis
  -webkit-box-orient vertical
  -webkit-line-clamp 4

</style>